var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter_1_",
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.568,14.179v-0.032c0.558-0.218,0.998-0.68,1.441-1.022c2-1.541,3.301-3.57,4.26-6.164 c-0.543,0.298-1.088,0.596-1.633,0.894c-1.681,0.853-4.533,2.079-6.728,2.267c-2.586-2.356-5.292-4.209-10.378-4.12 c-0.534,0.064-1.068,0.128-1.602,0.192c-1.037,0.227-2.025,0.508-2.916,0.894c-3.724,1.616-6.263,4.631-7.431,8.814 c-0.465,1.664-0.654,4.445-0.064,6.164c-2.101-0.003-4.135-0.334-5.894-0.767C18.69,19.594,14.372,17.29,9.578,13.54 C8.17,12.439,6.789,11.191,5.67,9.804C5.309,9.357,4.74,8.965,4.485,8.43C4.463,8.42,4.442,8.409,4.421,8.398 c-0.557,1.032-1.08,2.15-1.409,3.417c-1.3,4.994,0.755,9.188,2.947,11.912c0.664,0.826,1.741,1.338,2.402,2.108h0.064 c-0.497,0.184-1.361-0.071-1.794-0.16c-1.024-0.211-1.897-0.405-2.755-0.766c-0.448-0.213-0.897-0.426-1.345-0.639 c-0.021,5.517,2.766,9.103,6.182,11.241c1.114,0.697,2.672,1.636,4.292,1.724c-0.867,0.732-4.575,0.396-5.862,0.256 c1.609,4.142,4.081,6.9,8.328,8.398c1.096,0.387,2.433,0.729,3.908,0.703c-0.783,0.93-2.454,1.688-3.556,2.331 c-2.272,1.329-4.91,2.191-7.88,2.843c-1.191,0.26-2.457,0.207-3.748,0.414c-1.427,0.23-2.92-0.121-4.196-0.16 c0.384,0.234,0.769,0.47,1.153,0.703c1.171,0.713,2.394,1.338,3.716,1.916c2.379,1.041,4.914,1.826,7.72,2.523 c5.658,1.404,13.64,0.773,18.579-0.766c13.754-4.287,22.442-14.293,25.722-29.03c0.564-2.535,0.646-5.414,0.609-8.431 c0.684-0.543,1.367-1.086,2.05-1.629c1.693-1.356,3.28-3.246,4.452-5.11v-0.032C61.768,12.864,59.418,14.149,56.568,14.179z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.20eb81f63ce0329c6d9411651fc50c57.svg";
export { ForwardRef as ReactComponent };